<template>
  <el-dialog
    ref="dialog"
    title="信息核验"
    :visible.sync="dVisible"
    width="600px" 
    top="15vh"
    :append-to-body="true"
    @opened="handleDialogOpened"
    @closed="handleDialogClosed"
    @close="hide"
  >
    <div class="dialog-content">
       <div class="iframe-wrapper">
        <iframe 
          id="HTifreme" 
          :src="url" 
          ref="iframeRef"
        ></iframe>
      </div>
    
    </div>
  </el-dialog>
</template>

<script>
  import {Message} from 'element-ui';

//   const isEntClient = CheckLibs.isBigEngineerE() || CheckLibs.isGreatCraftsmanEnt();
  

  export default {
    
    components: {},
    data() {
      return {
        dVisible: false,
        url: '',
        resolvePromise: null, // 存储 resolve 函数
        rejectPromise: null   // 存储 reject 函数
      }
    },
    mounted() {
        this.initUrl();
    },
    methods: {

      initUrl() {
        if(window.md.getLoginInfo) {
           const {phone,userName, compName} = (parent.window || window).md.getLoginInfo();
            this.url = `https://cad.crowncad.com/bigEngineerRedirect?phone=${phone}&username=${userName}&companyName=${compName}&type=onlineEditing`
        }
        
      },
      // 监听 message 事件
      handleMessage(event) {
        
        try {
          const data = event.data;
          
          if (data && data.type === 'authFinish') {
            this.token = data.token;
            // 这里可以触发其他操作，比如自动关闭对话框或通知父组件
            Message.success('认证成功！');
           
            this.onOk();
            
          }
        } catch (error) {
          console.error('处理 iframe 消息出错:', error);
          Message.error('认证出现异常！');
        }
      },
      
      handleDialogOpened() {
        // 对话框打开时添加事件监听
        window.addEventListener('message', this.handleMessage);
      },
      
      handleDialogClosed() {
        // 对话框关闭时移除事件监听
        window.removeEventListener('message', this.handleMessage);
      },
      
      show() {
        this.dVisible = true;
         return new Promise((resolve, reject) => {
            this.resolvePromise = resolve;
            this.rejectPromise = reject;
        });
      },
      hide() {
        this.dVisible = false;
        if (this.rejectPromise) {
            this.rejectPromise(new Error('用户取消'));
            this.resolvePromise = null;
            this.rejectPromise = null;
        }
      },
       onOk() {
        if (this.token) {
            this.dVisible = false;
            // 传递 token 给调用者
            if (this.resolvePromise) {
                this.resolvePromise(this.token);
                this.resolvePromise = null;
                this.rejectPromise = null;
            }
        } else {
        console.log('请先完成认证');
        }
        },

    }
  }
</script>

<style scoped lang="less">
  .dialog-content {
    height: 400px;
    // border: 1px solid #ccc;
    overflow-y: auto;
    padding: 10px;

    .iframe-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        // border: 1px solid #ccc;
    }
    
    #HTifreme {
        width: 100%;
        height: 100%;
        border: none;
    }
  }
  .el-dialog__wrapper {
    /deep/ .el-dialog {
      .el-dialog__header {
        padding: 8px 10px;
        background: #f7f7f7;

        .el-dialog__title {
          font-size: 14px;
        }

        .el-dialog__headerbtn {
          top: 12px;
          right: 10px;
          line-height: 16px;
        }
      }

      .el-dialog__body {
        padding: 10px 10px 0 10px;
      }
    }
  }
</style>